export class BaseError extends Error {
  constructor(
    public readonly errorId: string,
    msg: string,
  ) {
    super("[" + errorId + "] " + msg);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, BaseError.prototype);
  }
}